



















import { Component, Vue } from "vue-property-decorator";
import userApi from "@/api/userApi";
import _ from "lodash";

@Component({
  name: 'ForgotPassword'
})
export default class ForgotPassword extends Vue {
  public form = {
    email: ""
  }
  public errorMessage = "";

  private async submit():Promise<void> {
    // Call api forgot password
    const response = await userApi.forgotPassword(this.form);

    if (_.get(response, 'meta.status') != 200) {
      // Show error
      this.errorMessage = _.get(response, 'meta.errors.email.0', _.get(response, 'meta.message'));
    } else {
      this.$emit('submit', this.form.email);
    }
  }

}
